import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

// stats--resources on `app/views/stats/quickblox_total.haml`.
export default class extends Controller {
  static targets = ["table", "chart"]

  static values = {
    graphUrl: { type: String, default: "/stats/global/graph" },
    tableUrl: { type: String, default: "/stats/global/resources" },
  }

  connect() {
    if (this.hasTableTarget) this.#initDataTable()
    if (this.hasChartTarget) this.#initChart()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      scrollX: true,
      ajax: {
        url: this.tableUrlValue,
        type: "POST",
      },
    })
  }

  #initChart() {
    Highcharts.setOptions({
      global: {
        useUTC: true,
      },
    })

    const controller = this

    this.chart = new Highcharts.Chart({
      chart: {
        animation: false,
        renderTo: this.chartTarget,
        type: "spline",
        events: {
          load() {
            controller.#loadGraphData()
          },
        },
      },
      title: { text: "" },
      xAxis: {
        type: "datetime",
      },
      yAxis: {
        min: 0,
        title: {
          text: "Count",
        },
      },
      series: [
        { data: [], name: "Accounts", data_name: "accounts_count" },
        { data: [], name: "API calls", data_name: "api_calls_count", visible: false },
        { data: [], name: "Apps", data_name: "applications_count", visible: false },
        { data: [], name: "Blobs", data_name: "blobs_count", visible: false },
        { data: [], name: "Blobs size", data_name: "blobs_total_size", visible: false },
        { data: [], name: "Traffic", data_name: "traffic_count", visible: false },
        { data: [], name: "CData", data_name: "custom_data_count", visible: false },
        { data: [], name: "Users", data_name: "users_count", visible: false },
        { data: [], name: "Events", data_name: "events_count", visible: false },
        { data: [], name: "FCM", data_name: "gcm_sent", visible: false },
        { data: [], name: "APNS", data_name: "apns_sent", visible: false },
        { data: [], name: "E-mail", data_name: "email_sent", visible: false },
        { data: [], name: "Chat presences count", data_name: "chat_presences_count", visible: false },
        { data: [], name: "Chat messages count", data_name: "chat_messages_count", visible: false },
        { data: [], name: "Address book contacts", data_name: "address_book_contacts_count", visible: false },
      ],
    })
    this.chart.showLoading()
  }

  #loadGraphData() {
    if (!this.chart) return

    $.ajax({
      url: this.graphUrlValue,
      success: (dataArr) => {
        if (!this.chart) return

        this.chart.series.forEach((currentSerie) => {
          const seriesData = dataArr[currentSerie.options.data_name]
          if (seriesData) {
            seriesData.forEach((val) => {
              currentSerie.addPoint(val, true)
            })
          }
        })
        this.chart.hideLoading()
      },
      cache: false,
    })
  }
}
